const enum AppRoute {
    HOME = '/',
    CITY_PINNER = '/CityPinner',
    CV_APP = '/CVApp',
    ONCRUITER = '/oncruiter',
    ASC = '/aventurasicalatorii',
    ATLAS = '/atlastravel',
    CHIRON = '/taberelechiron'
}

export default AppRoute;